import { language as ptBrLang } from './br';
import { language as enLang } from './en';
import { language as laLang } from './la';

export default {
  br: ptBrLang,
  en: enLang,
  la: laLang,
};
